import * as PIXI from 'pixi.js';
import Image from './Image';
import AssetManager from '../../../Base/AssetManager';
import { Shape } from '..';
import Global from '../../../Global';
import LibraryManager from '../../../Base/Library/LibraryManager';
import Angle from '../../../Base/Math/Angle';

export default class Pattern extends Image {
    onCreateVisuals() {
        const game = this.getGame();
        this.pixiContainer = new PIXI.Container();

        let ySize = this.state.blok.size.y;
        if (this.state.blok.shape === Shape.circle) ySize = this.state.blok.size.x;

        for (let i = 0; i < this.state.blok.size.x; i++) {
            for (let j = 0; j < ySize; j++) {
                let sprite = null;
                if (game.isCanvas()) {
                    sprite = new PIXI.Sprite(
                        LibraryManager.textures
                            .get(this.texture)
                            .getAsset()
                            .getHue(this.hue),
                        64,
                        64
                    );
                } else {
                    sprite = new PIXI.heaven.Sprite(LibraryManager.textures.get(this.texture).get());
                    sprite.color.hue = Angle.toRadians(this.hue);
                }
                sprite.width = Global.NATIVE_BLOCK_SIZE;
                sprite.height = Global.NATIVE_BLOCK_SIZE;
                sprite.anchor.set(0);
                sprite.position.x = (-this.state.blok.size.x / 2 + i) * Global.NATIVE_BLOCK_SIZE;
                sprite.position.y = (-ySize / 2 + j) * Global.NATIVE_BLOCK_SIZE;

                this.pixiContainer.addChild(sprite);
                this.sprites.push(sprite);
            }
        }

        if (this.state.blok.shape === Shape.circle) {
            this.createCircleMask();
        }

        this.state.getParentPixiContainer().addChild(this.pixiContainer);
    }
}
